import React, { useState } from "react";
import { cn } from "@/lib/utils";
import { InitialsAvatar } from "@/components/InitialsAvatar";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

const absUrl = (path) => {
    if (!path) return null;
    if (/^https?:\/\//i.test(path)) return path;
    return `${BACKEND_URL}${path}`;
};

/**
 * Renders an avatar portrait if a generated image is available;
 * otherwise falls back to InitialsAvatar.
 * Sizing is set by parent via className / explicit width/height.
 */
export const AvatarPortrait = ({
    name,
    imageUrl,
    aspect = "square", // "square" or "wide"
    className,
    dataTestId,
    rounded = "rounded-2xl",
}) => {
    const [errored, setErrored] = useState(false);
    const src = absUrl(imageUrl);
    const showImage = src && !errored;

    if (!showImage) {
        return (
            <div
                className={cn(
                    "flex items-center justify-center bg-gradient-to-br from-primary/20 to-accent/20",
                    aspect === "wide" ? "aspect-[4/3]" : "aspect-square",
                    rounded,
                    className
                )}
                data-testid={dataTestId}
            >
                <InitialsAvatar
                    name={name || "?"}
                    className="h-16 w-16 text-xl"
                    dataTestId={`${dataTestId || "avatar"}-initials`}
                />
            </div>
        );
    }
    return (
        <img
            src={src}
            alt={name}
            loading="lazy"
            onError={() => setErrored(true)}
            className={cn(
                "h-full w-full object-cover",
                aspect === "wide" ? "aspect-[4/3]" : "aspect-square",
                rounded,
                className
            )}
            data-testid={dataTestId}
        />
    );
};
